import resolveDsTheme from './resolveDsTheme';

/**
 * Applies design-system theme attribute to the app root (#app body element).
 */
const syncAppTheme = (theme) => {
  const body = document.getElementById('app');

  if (!body) {
    return;
  }

  body.setAttribute('data-ds-theme', resolveDsTheme(theme));
};

export default syncAppTheme;
